import { render, staticRenderFns } from "./producto-pedido.vue?vue&type=template&id=5793704a&scoped=true"
import script from "./producto-pedido.vue?vue&type=script&lang=js"
export * from "./producto-pedido.vue?vue&type=script&lang=js"
import style0 from "./producto-pedido.vue?vue&type=style&index=0&id=5793704a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5793704a",
  null
  
)

export default component.exports